import { blockConfigMap } from '@tmh-website/components/blocks-config';

/**
 * This option piece contains all relations that are part of some block type.
 */
export const blockPopulateOptions = {
  populate: ['backgroundImage', 'foregroundImage', 'image', 'images', 'logos', 'poster', 'video']
    .concat(
      Object.values(blockConfigMap)
        .map(blockConfig => (blockConfig ? blockConfig.populateOptions : []))
        .flat()
    )
    .flat(),
  metaImage: '*',
};

/**
 * Placeholder instead of the actual populate options `blockPopulateOptions` above.
 * This is being used to limit URL length to a reasonable length.
 *
 * @see `expandPlaceholderPopulateQuery` in `apps/cms/src/api/shared/services/page.ts`
 */
export const BlockPopulateOptionsPlaceholder = '_blockPopulateOptions';

/**
 * This option piece contains all relations that are part of article pages.
 */
export const articlePagePopulateOptions = {
  additionalTagEntries: '*',
  audiences: '*',
  author: {
    populate: ['image'],
  },
  speakers: {
    populate: ['image'],
  },
  statsEntries: '*',
  tags: '*',
  heroImage: '*',
  image: '*',
  partner: {
    populate: ['logo'],
  },
  enumerationList: {
    populate: ['enumerationListEntries'],
  },
};

export const articleCompactPagePopulateOptions = {
  additionalTagEntries: '*',
  audiences: '*',
  author: {
    populate: ['image'],
  },
  tags: '*',
  image: '*',
  partner: {
    populate: ['logo'],
  },
};

export const sitePopulateOptions = {
  homepageLinks: {
    populate: ['audience', 'page'],
  },
  navigation: {
    populate: ['image', 'link.image', 'children.image'],
  },
  navigationHighlights: { populate: ['children'] },
  menuQuickLinks: '*',
  footerLinkGroups: {
    populate: ['link', 'children'],
  },
  footerLegalLinks: '*',
  footerPartners: { populate: ['partnerLogosEntries.link', 'partnerLogosEntries.image'] },
  footerLogisticPartners: { populate: ['partnerLogosEntries.link', 'partnerLogosEntries.image'] },
  footerPaymentPartners: { populate: ['partnerLogosEntries.link', 'partnerLogosEntries.image'] },
  footerCertificates: { populate: ['partnerLogosEntries.link', 'partnerLogosEntries.image'] },
  socialLinks: '*',
  metaImage: '*',
};
